import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@ Injectable({providedIn: 'root'})
export class AccountingService {
	private url: string;
	constructor(private httpClient: HttpClient) {
		this.url = 'api/intacct';
	}

	public getOpenPeriodStart(): Observable<Date> {
		return this.httpClient.get<Date>(this.url + '/GetOpenPeriodStart');
	}

	public getVendorDueDateTerm(shopId: number): Observable<number> {
		return this.httpClient.get<number>(this.url + '/GetVendorDueDateTerm/' + shopId);
	}

	public getPurchaseOrder(invoiceNumber: string, shopId: number, isVendorRailroad: boolean = false): Observable<any> {
		return this.httpClient.get<any>(this.url + '/getPurchaseOrder', 
		{
			params: {
				'invoiceNumber': invoiceNumber.toString(),
				'shopId': shopId.toString(),
				'isVendorRailroad': isVendorRailroad.toString()
			}
		});
	}
}
